export default {
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back to home',
  'pages.user.login.title': 'Partner Management Platform Login',
  'pages.user.login.subTitle': 'Safe, efficient financial transaction experience',
  'pages.user.login.securityTips':
    'Your account security is our top priority. All transactions are protected by SSL encryption.',
  'pages.user.login.copyright': '© 2025 Trading Platform. All rights reserved.',
  'pages.user.login.placeholderEmail': 'Please enter your phone number or email address',
  'pages.user.login.placeholderPassword': 'Please enter your password',
  'pages.user.login.placeholderCaptcha': 'Please enter the verification code',
  'pages.user.login.loginButton': 'Login',
  'pages.user.login.loginLoading': 'Logging in...',
  'pages.user.login.getEmailCode': 'Get email verification code',
  'pages.user.login.getCaptcha': 'Get verification code',
  'pages.user.login.getGoogleCode': 'Get Google verification code',
  'pages.user.login.description': 'Safe, efficient financial transaction experience',
  'pages.user.login.emailAddress': 'Phone Number / Email',
  'pages.user.login.countryChina': 'China',
  'pages.user.login.password': 'Password',
  'pages.user.initPassword.title': 'Change Password',
  'pages.user.initPassword.welcome': 'Welcome: {userName}-{email}',
  'pages.user.initPassword.description':
    'Since you are logging in for the first time, in order to ensure the security of your account, please change your password, and then log in again.',
  'pages.user.initPassword.newPassword': 'New Password',
  'pages.user.initPassword.confirmPassword': 'Confirm Password',
  'pages.user.initPassword.submit': 'Submit',
  'pages.user.initPassword.oldPassword': 'Old Password',
  'pages.user.initPassword.oldPasswordRequired': 'Please enter the old password',
  'pages.user.initPassword.oldPasswordPlaceholder': 'Please enter the old password',
  'pages.user.initPassword.newPasswordRequired': 'Please enter the new password',
  'pages.user.initPassword.passwordMinLength': 'Password length must be at least 8 characters',
  'pages.user.initPassword.passwordMismatch': 'New password and confirm password do not match',
  'pages.user.initPassword.confirmPasswordPlaceholder': 'Please enter the confirm password',
  'pages.user.initPassword.confirmPasswordRequired': 'Please enter the confirm password',
  'pages.user.initPassword.newPasswordPlaceholder': 'Please enter the new password',
  'pages.common.status': 'Status',
  'pages.common.createTime': 'Create Time',
  'pages.common.option': 'Option',
  'pages.common.orderNum': 'Order Number',
  'pages.common.keywordSearch': 'Keyword',
  'pages.common.serialNumber': 'Serial Number',
  'pages.common.remark': 'Remark',
  'pages.common.updateRemark': 'Update Remark',
  'pages.common.inviteCodeCustomize': 'Invite Code (Custom)',
  'pages.common.inviteCode': 'Invite Code',
  'pages.common.inviteLink': 'Invite Link',
  'pages.common.statisticsTimeTooltip': 'Real-time statistics of each commission income, distributed at 6:00 each day',
  'pages.common.statisticsTimeTooltip2': 'Distributed at 6:00 each day',
  'pages.common.settlementTime': 'Settlement Time',
  'pages.common.equivalentUSDT': 'Equivalent USDT',
  'pages.common.specifiedSubordinateUID': 'Downline Team UID',
  'pages.common.pleaseEnterUID': 'Search sub-affiliates UID',
  'pages.common.pleaseEnterUIDDescription':
    'Enter the UID of any subordinate member, and the system will display the data of the subordinate users starting from that user',
  'pages.team.teamLeaderQueryDirectOnly': 'Direct Subordinates Only',
  'pages.team.teamLeaderQueryAllUnder': 'All Under Umbrella',
  'pages.common.systemDefault': 'System Default',
  'pages.system.user.loginAccount': 'Login Account',
  'pages.system.user.userName': 'User Name',
  'pages.system.user.nickName': 'Nick Name',
  'pages.system.user.role': 'Role',
  'pages.system.user.email': 'Email',
  'pages.system.user.phone': 'Phone',
  'pages.system.user.password': 'Password',
  'pages.system.user.addUser': 'Add User',
  'pages.system.user.editUser': 'Edit User',
  'pages.system.user.resetPassword': 'Reset Password',
  'pages.system.user.assignRole': 'Assign Role',
  'pages.system.user.confirmPassword': 'Confirm Password',
  'pages.system.user.emailInvalid': 'Please enter a valid email address',
  'pages.system.user.uidInvalid': 'Please enter a valid UID',
  'pages.system.user.phoneInvalid': 'Please enter a valid phone number',
  'pages.system.user.passwordInvalid':
    'Password length must be at least 8 characters, at least three of which are: uppercase and lowercase letters, numbers, and special symbols',
  'pages.system.user.userNameLength': 'User name length is 2-20 characters',
  'pages.system.role.roleName': 'Role Name',
  'pages.system.role.roleKey': 'Permission Character',
  'pages.system.role.admin': 'Is Admin',
  'pages.system.role.roleSort': 'Order Number',
  'pages.system.role.menuPermission': 'Menu Permission',
  'pages.system.role.dataScope': 'Data Scope',
  'pages.system.role.allDataScope': 'All Data Permission',
  'pages.system.role.customDataScope': 'Custom Data Permission',
  'pages.system.role.deptDataScope': 'Department Data Permission',
  'pages.system.role.deptAndBelowDataScope': 'Department and Below Data Permission',
  'pages.system.role.onlySelfDataScope': 'Only Self Data Permission',
  'pages.system.role.dataPermission': 'Data Permission',
  'pages.system.role.addRole': 'Add Role',
  'pages.system.role.editRole': 'Edit Role',
  'pages.system.role.roleKeyInvalid':
    'Please enter permission characters consisting of uppercase and lowercase letters',
  'pages.system.menu.menuName': 'Menu Name',
  'pages.system.menu.perms': 'Permission Character',
  'pages.system.menu.menuType': 'Menu Type',
  'pages.system.menu.topMenu': 'Top Menu',
  'pages.system.menu.parentMenu': 'Parent Menu',
  'pages.system.menu.addMenu': 'Add Menu',
  'pages.system.menu.editMenu': 'Edit Menu',
  'pages.system.dept.deptName': 'Department Name',
  'pages.system.dept.topDept': 'Top Department',
  'pages.system.dept.addDept': 'Add Department',
  'pages.system.dept.editDept': 'Edit Department',
  'pages.system.dept.parentDept': 'Parent Department',
  'pages.system.dept.leader': 'Leader',
  'pages.system.dept.phone': 'Phone',
  'pages.system.dept.email': 'Email',
  'pages.system.permissions.bdList': 'BD List',
  'pages.system.permissions.partnerList': 'Partner List',
  'pages.system.permissions.searchBd': 'Search BD Name...',
  'pages.system.permissions.partnerLevel': 'Partner Level',
  'pages.system.permissions.partnerLevelDescription': 'Please select a BD to view the partner level',
  'pages.system.permissions.noPartner': 'No partner data for this BD',
  'pages.system.permissions.noBd': 'No BD data',
  'pages.system.permissions.confirmTransfer': 'Confirm Transfer',
  'pages.system.permissions.confirmTransferDescription':
    'Are you sure you want to transfer this node and its data? (And inherit the invite relationship of the upper and lower levels)',
  'pages.system.permissions.confirmTransferDescription2':
    'Note: The rebate ratio of the dragged node is greater than the new node, please go to modify the rebate ratio of the new node to be equal to or greater than the dragged node ratio, otherwise it will not be able to rebate.',
  'pages.system.permissions.transferNode': 'Transfer Node',
  'pages.system.permissions.targetBd': 'Target BD',
  'pages.system.permissions.targetNode': 'Target Node',
  'pages.system.permissions.toRootLevel': 'Set to the highest level',
  'pages.account.settings.base': 'Base Information',
  'pages.account.settings.binding': 'Google Bind',
  'pages.account.settings.password': 'Change Password',
  'pages.account.settings.googleBind': 'Google Authenticator Bind',
  'pages.account.settings.googleUnbind': 'Google Authenticator Unbind',
  'pages.account.settings.googleBindDescription':
    'Binding Google Authenticator can provide additional security protection for your account. You need to enter a dynamic verification code each time you log in.',
  'pages.account.settings.googleBindSuccess': 'Google Authenticator Bind Success',
  'pages.account.settings.googleBindSuccessDescription':
    'Your account has been successfully bound to Google Authenticator, and you will need to enter a dynamic verification code when logging in.',
  'pages.account.settings.googleBindStep1': '1. Install Google Authenticator on your phone',
  'pages.account.settings.googleBindStep2': '2. Open the application and click the "+" button',
  'pages.account.settings.googleBindStep3': '3. Select "Scan barcode" or "Manually input key"',
  'pages.account.settings.googleBindStep4': '4. Scan the QR code or input the key',
  'pages.account.settings.googleBindStep5': 'Manually input key:',
  'pages.account.settings.emailVerificationCode': 'Email Verification Code',
  'pages.account.settings.pleaseEnterEmailVerificationCode': 'Please enter the email verification code',
  'pages.account.settings.getVerificationCode': 'Get Verification Code',
  'pages.account.settings.secondsLater': 'Seconds later to get',
  'pages.account.settings.googleVerificationCode': 'Google Verification Code',
  'pages.account.settings.pleaseEnterGoogleVerificationCode':
    'Please enter the 6-digit verification code in Google Authenticator',
  'pages.account.settings.pleaseEnter6DigitVerificationCode': 'Please enter the 6-digit verification code',
  'pages.account.settings.googleBindNot': 'Google Authenticator Not Bound',
  'pages.account.settings.scanGoogleAuthenticator': 'Step 1: Scan the QR code',
  'pages.account.settings.bindGoogleAuthenticator': 'Step 2: Verify the binding',
  'pages.account.settings.userId': 'User ID',
  'pages.account.settings.loginAccount': 'Login Account',
  'pages.account.settings.userNickname': 'User Nickname',
  'pages.account.settings.gender': 'Gender',
  'pages.account.settings.male': 'Male',
  'pages.account.settings.female': 'Female',
  'pages.account.settings.unknown': 'Unknown',
  'pages.account.settings.department': 'Department',
  'pages.account.settings.notAssigned': 'Not Assigned',
  'pages.account.settings.notSet': 'Not Set',
  'pages.account.settings.createTime': 'Create Time',
  'pages.account.settings.rolePermission': 'Role Permission',
  'pages.account.settings.roles': 'Roles',
  'pages.account.settings.noRoles': 'No Roles',
  'pages.account.settings.permissions': 'Permissions',
  'pages.account.settings.noPermissions': 'No Permissions',
  'pages.account.settings.loginInfo': 'Login Info',
  'pages.account.settings.lastLoginIp': 'Last Login IP',
  'pages.account.settings.lastLoginTime': 'Last Login Time',
  'pages.account.settings.passwordUpdateTime': 'Password Update Time',
  'pages.account.settings.creator': 'Creator',
  'pages.account.settings.system': 'System',
  'pages.account.settings.noUserInfo': 'No User Info',
  'pages.account.settings.username': 'Username',
  'pages.account.settings.normal': 'Normal',
  'pages.account.settings.disabled': 'Disabled',
  'pages.account.settings.googleBindPassword': 'Change password requires binding Google Authenticator',
  'pages.account.help.systemInfo': 'System Info',
  'pages.account.help.systemTime': 'System Time',
  'pages.account.help.systemVersion': 'System Version',
  'pages.account.help.systemTimeDescription':
    'All times in this system are based on *UTC+0 (Coordinated Universal Time)* standard. Please convert them according to your time zone.',
  'pages.log.operate.title': 'Operate Log',
  'pages.log.operate.id': 'Log ID',
  'pages.log.operate.systemModule': 'System Module',
  'pages.log.operate.operationType': 'Operation Type',
  'pages.log.operate.operationPerson': 'Operation Person',
  'pages.log.operate.operationAddress': 'Operation Address',
  'pages.log.operate.operationLocation': 'Operation Location',
  'pages.log.operate.operationStatus': 'Operation Status',
  'pages.log.operate.operationDate': 'Operation Date',
  'pages.log.operate.operationTime': 'Operation Time',
  'pages.log.operate.details': 'Operation Log Details',
  'pages.log.operate.requestMethod': 'Request Method',
  'pages.log.operate.requestParam': 'Request Param',
  'pages.log.operate.responseResult': 'Response Result',
  'pages.log.operate.loginInfo': 'Login Info',
  'pages.log.operate.requestAddress': 'Request Address',
  'pages.log.operate.operationMethod': 'Operation Method',
  'pages.log.login.title': 'Login Log',
  'pages.log.login.infoId': 'Access ID',
  'pages.log.login.userName': 'User Name',
  'pages.log.login.loginAddress': 'Login Address',
  'pages.log.login.loginStatus': 'Login Status',
  'pages.log.login.operationInfo': 'Operation Info',
  'pages.log.login.loginDate': 'Login Date',
  'pages.bd.user.title': 'BD User Management',
  'pages.bd.user.name': 'Name',
  'pages.bd.user.officialEmail': 'Official Email',
  'pages.bd.user.bdType': 'BD Type',
  'pages.bd.user.teamSize': 'Team Size',
  'pages.bd.user.socialMedia': 'Verified Links',
  'pages.bd.user.socialMediaCount': '{count} links',
  'pages.bd.user.commission': 'Participate in Commission',
  'pages.bd.user.addTime': 'Add Time',
  'pages.bd.user.add': 'Upgrade Partner',
  'pages.bd.user.edit': 'Edit Partner',
  'pages.bd.user.spotCommission': 'Spot Commission Configuration',
  'pages.bd.user.futuresCommission': 'Futures Commission Configuration',
  'pages.bd.user.commissionStrategy': 'Commission Strategy',
  'pages.bd.user.loginEmail': 'Login Email',
  'pages.bd.user.position': 'Position',
  'pages.bd.user.bdCommission': 'BD Commission Configuration',
  'pages.bd.user.notificationLanguage': 'Notification Language',
  'pages.bd.user.emailRuleTip':
    'The @bitbaby.com suffix restriction has been removed. General email addresses are now supported.',
  'pages.bd.user.setFuturesRebate': 'Set Futures Level Difference Rebate Ratio',
  'pages.bd.user.setSpotRebate': 'Set Spot Ratio Rebate',
  'pages.bd.user.editSocialMedia': 'Edit Social Media',
  'pages.futures.rebate.title': 'Futures Rebate Configuration',
  'pages.futures.rebate.childName': 'Child Name',
  'pages.futures.rebate.creator': 'Creator',
  'pages.futures.rebate.rebateStrategy': 'Rebate Strategy',
  'pages.futures.rebate.splitType': 'Split Type',
  'pages.futures.rebate.partner': 'Partner',
  'pages.futures.rebate.add': 'Add Rebate Configuration',
  'pages.futures.rebate.edit': 'Edit Rebate Configuration',
  'pages.futures.rebate.strategyName': 'Strategy Name',
  'pages.futures.rebate.rebateScale': 'Rebate Scale',
  'pages.futures.rebate.rebateLevel': 'Rebate Level',
  'pages.futures.rebate.addLevel': 'Add Level',
  'pages.futures.rebate.deleteLevel': 'Delete Level',
  'pages.futures.rebate.maxLevels': 'Maximum 10 levels can be added',
  'pages.futures.rebate.agentDescription': 'Agent can get the rebate of the next 10 levels and self-rebate',
  'pages.futures.rebate.baseDescription': 'Base Rebate Configuration',
  'pages.futures.rebate.baseDescriptionDescription': 'Description:',
  'pages.futures.rebate.baseDescriptionDescription1':
    '1、Used to set the proportion of the ordinary user recommended friend to get the rebate of the futures transaction.',
  'pages.futures.rebate.baseDescriptionDescription2':
    '2、This amount is extra by the exchange, if configured 0, it does not support ordinary user rebate.',
  'pages.futures.rebate.myIdentityDescription': 'My identity: {name} Rebate ratio: {returnScale}',
  'pages.futures.rebate.setCustomInviteCode': 'Set Custom Invite Code',
  'pages.futures.rebate.inviteCodeDescription':
    'Invite code content must comply with the laws and regulations of the country/region, and the platform has the right to modify or impose penalties such as account suspension if it is found to be in violation.',
  'pages.futures.rebate.inviteCodeDescription1': 'Custom invite code is unique and not allowed to be duplicated.',
  'pages.futures.rebate.inviteCodeDescription2':
    'Custom invite code is limited to 4-10 characters, consisting of letters and numbers.',
  'pages.futures.rebate.inviteCodeDescription3':
    'After the custom invite code is set successfully, if it has been released, it is recommended not to replace or delete it lightly, to avoid the situation where the custom invite code becomes invalid and the invitation fails.',
  'page.futures.rebate.setCustomInviteCodePlaceholder':
    'Please enter 4 to 10 characters, including at least two of the following: uppercase letters, lowercase letters, and numbers.',
  'pages.futures.rebate.inviteCodeTips': 'Tips:',
  'pages.futures.team.userName': 'User Name',
  'pages.futures.team.email': 'Email',
  'pages.futures.team.identity': 'Identity',
  'pages.futures.team.partnerIdentity': 'Partner Identity',
  'pages.futures.team.teamNum': 'Team Number',
  'pages.futures.team.personalMonthVolume': 'Personal Month Volume (Equivalent USDT)',
  'pages.futures.team.teamMonthVolume': 'Team Month Volume (Equivalent USDT)',
  'pages.futures.team.totalCommission': 'Total Commission (Equivalent USDT)',
  'pages.futures.team.viewInviteChain': 'View Invite Chain Path',
  'pages.futures.team.searchUid': 'Please enter UID to search',
  'pages.futures.team.basicInfo': 'Basic Information',
  'pages.futures.team.dataOverview': 'Data Overview',
  'pages.futures.team.accountOverview': 'Account Overview',
  'pages.futures.team.currency': 'Currency',
  'pages.futures.team.performanceOverview': 'Performance Overview',
  'pages.futures.team.superiorUid': 'Superior UID',
  'pages.futures.team.identityVerification': 'Identity Verification',
  'pages.futures.team.partner': 'Partner',
  'pages.futures.team.commissionRatio': 'Commission Ratio',
  'pages.futures.team.registerTime': 'Register Time',
  'pages.futures.team.totalAssets': 'Total Assets',
  'pages.futures.team.totalAssetsCurrency': 'Total Assets (Equivalent {currency})',
  'pages.futures.team.futuresAccountCurrency': 'Futures Assets (Equivalent {currency})',
  'pages.futures.team.spotAccountCurrency': 'Spot Assets (Equivalent {currency})',
  'pages.futures.team.futuresAccount': 'Futures Account',
  'pages.futures.team.netAssets': 'Net Assets',
  'pages.futures.team.holdingAmount': 'Holding Amount',
  'pages.futures.team.holdingAmountUSDT': 'Holding Amount USDT',
  'pages.futures.team.holdingAmountUSDC': 'Holding Amount USDC',
  'pages.futures.team.teamTotalNum': 'Team Total Number',
  'pages.futures.team.directInviteNum': 'Direct Invite Number',
  'pages.futures.team.kycVerifiedNum': 'KYC Verified Number',
  'pages.futures.team.transactionVolume': 'Transaction Volume',
  'pages.futures.team.rechargeAmount': 'Recharge Amount',
  'pages.futures.team.withdrawalAmount': 'Withdrawal Amount',
  'pages.futures.team.commissionIncome': 'Commission Income',
  'pages.futures.team.teamTransactionVolume': 'Team Transaction Volume',
  'pages.futures.team.teamRechargeAmount': 'Team Recharge Amount',
  'pages.futures.team.teamWithdrawalAmount': 'Team Withdrawal Amount',
  'pages.futures.team.teamCommissionIncome': 'Team Commission Income',
  'pages.futures.team.teamActiveNum': 'Team Active Number',
  'pages.futures.team.teamTransactionUserNum': 'Team Transaction User Number',
  'pages.futures.team.teamFirstTradeUserNum': 'Team First Trade User Number',
  'pages.futures.team.teamFirstRechargeUserNum': 'Team First Recharge User Number',
  'pages.futures.team.teamActiveUserNumTips': 'Non-real-time data statistics, not including the current day',
  'pages.futures.team.selectDateRange': 'Please select the start and end date and time',
  'pages.futures.team.all': 'All',
  'pages.futures.team.verified': 'Verified',
  'pages.futures.team.unverified': 'Unverified',
  'pages.futures.team.phone': 'Phone',
  'pages.futures.team.isPartner': 'Is Partner',
  'pages.futures.team.userList': 'User List',
  'pages.futures.team.upgradePartner': 'Upgrade Partner',
  'pages.futures.team.searchUidDescription': 'Enter UID to search or wait for data loading',
  'pages.futures.team.upgradePartnerDescription': 'UID/email/phone number',
  'pages.futures.team.theyAre': 'They are',
  'pages.futures.team.myInviteCode': 'My Invite Code：',
  'pages.futures.tradingVolume.teamTradingVolume': 'Team Trading Volume',
  'pages.futures.tradingVolume.transactionDate': 'Transaction Date',
  'pages.futures.tradingVolume.inviterUID': 'Inviter UID',
  'pages.futures.tradingVolume.commissionLevel': 'CommissionLevel',
  'pages.futures.tradingVolume.currencyAmount': 'Currency Amount',
  'pages.futures.tradingVolume.tradingVolume': 'Trading Volume（Equivalent USDT）',
  'pages.futures.tradingVolume.amountRange': 'Amount Range',
  'pages.futures.tradingVolume.tradingAmount': 'Trading Amount',
  'pages.futures.tradingVolume.theAbove': 'The above {volume}USDT ',
  'pages.futures.teamCommission.title': 'Team Commission',
  'pages.futures.teamCommission.titleList': 'Futures Team Commission',
  'pages.futures.teamCommission.statisticsTime': 'Statistics Time',
  'pages.futures.teamCommission.settlementTime': 'Settlement Time',
  'pages.futures.teamCommission.email': 'Email',
  'pages.futures.teamCommission.phone': 'Phone',
  'pages.futures.teamCommission.isPartner': 'Is Partner',
  'pages.futures.teamCommission.partnerIdentity': 'Partner Identity',
  'pages.futures.teamCommission.traderUID': 'Trader UID',
  'pages.futures.teamCommission.rebateLevel': 'Rebate Level',
  'pages.futures.teamCommission.rebateScale': 'Rebate Scale',
  'pages.futures.teamCommission.transactionType': 'Transaction Type',
  'pages.futures.teamCommission.rebateFee': 'Rebate Fee',
  'pages.futures.teamCommission.rebateAmount': 'Rebate Amount（Equivalent USDT）',
  'pages.futures.teamCommission.rebateStatus': 'Rebate Status',
  'pages.futures.teamCommission.tradingCurrency': 'Trading Currency',
  'pages.futures.teamCommission.commissionTotal': 'Commission Total(Equivalent USDT)：{total} USDT',
  'pages.futures.teamCommission.commissionTotalTime': 'Latest Rebate Settlement：{time}',
  'pages.futures.teamCommission.rebateNumber': 'Rebate Number(Equivalent USDT)',
  'pages.futures.teamCommission.rebateNumberTitle': 'Rebate Number',
  'pages.futures.teamCommission.participateCurrency': 'Fee Currency',
  'pages.futures.teamCommission.rebateCurrency': 'Rebate Currency',
  'pages.futures.subordinatePosition.currentPosition': 'Current Position',
  'pages.futures.subordinatePosition.historyPosition': 'History Position',
  'pages.futures.subordinatePosition.openTime': 'Open Time',
  'pages.futures.subordinatePosition.openPrice': 'Open Price',
  'pages.futures.subordinatePosition.positionCount': 'Position Count',
  'pages.futures.subordinatePosition.currentPrice': 'Current Price',
  'pages.futures.subordinatePosition.currentPositionAverage': 'Current Position Average',
  'pages.futures.subordinatePosition.longShortRatio': 'Long Short Ratio',
  'pages.futures.subordinatePosition.closeTime': 'Close Time',
  'pages.futures.subordinatePosition.closePrice': 'Close Price',
  'pages.futures.subordinatePosition.fee': 'Fee',
  'pages.futures.subordinatePosition.openAmount': 'Margin',
  'pages.futures.commissionSummary.dateRange': 'Date Range',
  'pages.futures.commissionSummary.tradeType': 'Trade Type',
  'pages.futures.commissionSummary.uid': 'UID',
  'pages.futures.commissionSummary.superiorUid': 'Superior UID',
  'pages.futures.commissionSummary.specifiedSubordinateUid': 'Downline Team UID',
  'pages.futures.commissionSummary.userType': 'User Type',
  'pages.futures.commissionSummary.all': 'All',
  'pages.futures.commissionSummary.directUser': 'Direct User',
  'pages.futures.commissionSummary.directAgent': 'Direct Agent',
  'pages.futures.commissionSummary.indirectUser': 'Indirect User',
  'pages.futures.commissionSummary.indirectAgent': 'Indirect Agent',
  'pages.futures.commissionSummary.self': 'Self',
  'pages.futures.commissionSummary.pleaseSelect': 'Please Select',
  'pages.futures.commissionSummary.pleaseEnter': 'Please Enter',
  'pages.futures.commissionSummary.date': 'Date',
  'pages.futures.commissionSummary.commissionRecipientUid': 'Commission Recipient UID',
  'pages.futures.commissionSummary.titleList': 'Futures Commission Summary',
  'pages.futures.commissionSummary.cumulativeTradingVolume': 'Cumulative Trading Volume',
  'pages.futures.commissionSummary.cumulativeFee': 'Cumulative Handling Fee',
  'pages.futures.commissionSummary.cumulativeCommission': 'Cumulative Commission Income: {total} USDT',
  'pages.futures.commissionSummary.dataNotice':
    'Data statistics: The rebate calculation and storage of the previous day are completed at 7 a.m. UTC+0, and there may be a short delay. Data display is equivalent to USDT statistics, and the data to be settled will be updated on a rolling basis from time to time (updated approximately every 10 minutes).',
  'pages.futures.commissionDetails.dateRange': 'Date Range',
  'pages.futures.commissionDetails.tradeType': 'Trade Type',
  'pages.futures.commissionDetails.uid': 'UID',
  'pages.futures.commissionDetails.superiorUid': 'Superior UID',
  'pages.futures.commissionDetails.traderUid': 'Trader UID',
  'pages.futures.commissionDetails.specifiedSubordinateUid': 'Downline Team UID',
  'pages.futures.commissionDetails.userType': 'User Type',
  'pages.futures.commissionDetails.settlementStatus': 'Settlement Status',
  'pages.futures.commissionDetails.all': 'All',
  'pages.futures.commissionDetails.self': 'Self',
  'pages.futures.commissionDetails.directUser': 'Direct User',
  'pages.futures.commissionDetails.directAgent': 'Direct Agent User',
  'pages.futures.commissionDetails.indirectUser': 'Indirect User',
  'pages.futures.commissionDetails.indirectAgent': 'Indirect Agent User',
  'pages.futures.commissionDetails.pendingSettlement': 'Pending Settlement',
  'pages.futures.commissionDetails.settled': 'Settled',
  'pages.futures.commissionDetails.pleaseSelect': 'Please Select',
  'pages.futures.commissionDetails.pleaseEnter': 'Please Enter',
  'pages.futures.commissionDetails.date': 'Date',
  'pages.futures.commissionDetails.commissionRecipientUid': 'Commission Recipient UID',
  'pages.futures.commissionDetails.rebateProviderUid': 'Rebate Provider UID',
  'pages.futures.commissionDetails.tradingVolume': 'Trading Volume',
  'pages.futures.commissionDetails.tradingVolumeTooltip':
    'Total trading volume generated by the rebate trader user within the day',
  'pages.futures.commissionDetails.fee': 'Fee',
  'pages.futures.commissionDetails.originalFee': 'Original Fee',
  'pages.futures.commissionDetails.originalFeeTooltip': 'Total fee generated by the rebate trader user within the day',
  'pages.futures.commissionDetails.experienceFeeResistance': 'Experience Fee Resistance',
  'pages.futures.commissionDetails.experienceFeeResistanceTooltip':
    'The part of the experience fee deduction does not generate fee income, and is not included in the rebate base',
  'pages.futures.commissionDetails.futuresExperienceFeeResistance': 'Futures Experience Fee Resistance',
  'pages.futures.commissionDetails.futuresExperienceFeeResistanceTooltip':
    'The part of the futures experience fee deduction does not generate fee income, and is not included in the rebate base',
  'pages.futures.commissionDetails.actualFee': 'Actual Fee',
  'pages.futures.commissionDetails.actualFeeTooltip': 'Actual Fee = Original Fee - Deduction Amount',
  'pages.futures.commissionDetails.rebateAmount': 'Rebate Amount',
  'pages.futures.commissionDetails.cumulativeTradingVolume': 'Cumulative Trading Volume',
  'pages.futures.commissionDetails.cumulativeFee': 'Cumulative Handling Fee',
  'pages.futures.commissionDetails.cumulativeCommission': 'Cumulative Commission Income：{total} USDT',
  'pages.futures.commissionDetails.cumulativeTotalFee': 'Cumulative Handling Fee：{total} USDT',
  'pages.futures.commissionDetails.cumulativeActualFee': 'Cumulative Actual Fee：{total} USDT',
  'pages.futures.commissionDetails.dataNotice':
    'Data statistics: The rebate calculation and storage of the previous day are completed at 7 a.m. UTC+0, and there may be a short delay. Data display is equivalent to USDT statistics, and the data to be settled will be updated on a rolling basis from time to time (updated approximately every 10 minutes).',
  'pages.futures.commissionDetails.pendingSettlementTitle': 'Pending Settlement Status Conditions Exist',
  'pages.futures.commissionDetails.pendingSettlementDesc1':
    'When BD does not rebate, the status will be pending settlement.',
  'pages.futures.commissionDetails.pendingSettlementDesc2':
    "When the BD status changes from no rebate to rebate, the rebate calculation will start from the day of modification. If the previous day's settlement task has already run, it will not be settled again. Then, from the current day, the rebate settlement will be converted, and historical pending settlements will not be settled.",
  'pages.futures.commissionDetails.bottomNotice':
    'If the transaction time cannot be counted, the transaction for that day will be counted',
  'pages.futures.commissionDetails.title': 'Futures Commission Details',
  'pages.spot.rebate.symbol': 'Symbol',
  'pages.spot.rebate.all': 'All',
  'pages.spot.rebate.rebateSymbol': 'Rebate Symbol',
  'pages.spot.rebate.childRole': 'Child Role',
  'pages.spot.rebate.rebateLevel': 'Rebate Level',
  'pages.spot.rebate.rebateScale': 'Rebate Scale',
  'pages.spot.rebate.level': 'Level',
  'pages.spot.team.spotAccount': 'Spot Account',
  'pages.spot.teamCommission.titleList': 'Spot Team Commission',
  'pages.rechargeRecord.title': 'Recharge Record',
  'pages.rechargeRecord.rechargeUserUid': 'Recharge User UID',
  'recharge.user.uid': 'Recharge User UID',
  'pages.rechargeRecord.rechargeDate': 'Recharge Date',
  'pages.rechargeRecord.fromUid': 'From Account ID',
  'pages.rechargeRecord.depositType': 'Deposit Type',
  'pages.rechargeRecord.volume': 'Volume',
  'pages.rechargeRecord.amount': 'Amount(Equivalent USDT)',
  'pages.rechargeRecord.symbol': 'Symbol',
  'pages.rechargeRecord.pid': 'Parent ID',
  'pages.rechargeRecord.level': 'Level',
  'pages.rechargeRecord.totalRecharge': 'Total Recharge(Equivalent USDT)',
  'pages.rechargeRecord.blockchainTransactionId': 'Blockchain Transaction ID',
  'pages.withdrawRecord.title': 'Withdrawal Record',
  'pages.withdrawRecord.withdrawDate': 'Withdrawal Date',
  'pages.withdrawRecord.withdrawUserUid': 'Withdrawal User UID',
  'pages.withdrawRecord.withdrawType': 'Withdrawal Type',
  'pages.withdrawRecord.reference': 'Transfer UID / TxID / U-Card No.',
  'pages.withdrawRecord.referenceOnChain': 'Blockchain Transaction ID',
  'pages.withdrawRecord.referenceInternal': 'Transfer User UID',
  'pages.withdrawRecord.referenceUCard': 'U-Card Number',
  'pages.withdrawRecord.symbol': 'Symbol',
  'pages.withdrawRecord.pid': 'Inviter UID',
  'pages.withdrawRecord.volume': 'Withdrawal Quantity',
  'pages.withdrawRecord.amount': 'Withdrawal Amount (Equivalent USDT)',
  'pages.withdrawRecord.totalWithdraw': 'Total Withdrawal (Equivalent USDT)',
  'pages.withdrawRecord.toUid': 'Transfer User UID',
  'pages.transferRecord.title': 'Transfer Record',
  'pages.transferRecord.transferDate': 'Transfer Date',
  'pages.transferRecord.transferUserUid': 'Transfer User UID',
  'pages.transferRecord.fromAccount': 'From Account',
  'pages.transferRecord.toAccount': 'To Account',
  'pages.transferRecord.symbol': 'Symbol',
  'pages.transferRecord.pid': 'Inviter UID',
  'pages.transferRecord.volume': 'Transfer Quantity',
  'pages.transferRecord.spotAccount': 'Spot Account',
  'pages.transferRecord.futuresAccount': 'Futures Account',
  'pages.activityData.search.registerDateRange': 'Register Date',
  'pages.activityData.search.statDateRange': 'Statistics Date',
  'pages.activityData.search.volumeQuery': 'Trading Amount',
  'pages.activityData.search.volumeQueryPlaceholder': 'Trading Amount',
  'pages.activityData.search.volumeQueryUnitMinute': 'Minute',
  'pages.activityData.search.volumeQueryUnitHour': 'Hour',
  'pages.activityData.search.diffSeconds': 'Time Difference (Seconds)',
  'pages.activityData.search.orderOffsetPct': 'Order Amount Similarity (%)',
  'pages.activityData.search.pleaseEnter': 'Please Enter',
  'pages.activityData.table.uid': 'UID',
  'pages.activityData.table.isPartnership': 'Is Partner',
  'pages.activityData.table.registerDate': 'Register Date',
  'pages.activityData.table.inviterUid': 'Inviter UID',
  'pages.activityData.table.futuresVolume': 'Futures Trading Volume',
  'pages.activityData.table.spotVolume': 'Spot Trading Volume',
  'pages.activityData.table.realizedProfit': 'Realized PnL',
  'pages.activityData.table.originalFee': 'Original Fee',
  'pages.activityData.table.userFee': 'Actual Fee',
  'pages.activityData.table.depositUsdt': 'Deposit USDT',
  'pages.activityData.table.withdrawUsdt': 'Withdraw USDT',
  'pages.activityData.table.netDepositUsdt': 'Net Deposit USDT',
  'pages.activityData.table.ipUidList': 'IP/UID',
  'pages.activityData.table.deviceUidList': 'Device ID/UID',
  'pages.activityData.table.hedgeAmount': 'Hedge Amount',
  'pages.activityData.table.fiveMinVolume': '5-Minute Volume',
  'pages.activityData.table.periodVolumeMinute': '{value}-Min Trading Volume',
  'pages.activityData.table.periodVolumeHour': '{value}-Hour Trading Volume',
  'pages.activityData.table.country': 'Country',
  'pages.activityData.message.fetchFailed': 'Failed to fetch list',
  'pages.activityData.unit.second': 'Sec',
  'pages.activityData.hedgeDetail.title': 'Hedge Detail Ledger',
  'pages.activityData.hedgeDetail.searchUid': 'Search UID',
  'pages.activityData.hedgeDetail.search.dealTimeRange': 'Deal Time',
  'pages.activityData.hedgeDetail.table.uid': 'UID',
  'pages.activityData.hedgeDetail.table.symbol': 'Symbol',
  'pages.activityData.hedgeDetail.table.tradeType': 'Trade Type',
  'pages.activityData.hedgeDetail.table.leverage': 'Leverage',
  'pages.activityData.hedgeDetail.table.orderTime': 'Order Time',
  'pages.activityData.hedgeDetail.table.orderPrice': 'Order Price',
  'pages.activityData.hedgeDetail.table.orderVolume': 'Order Volume',
  'pages.activityData.hedgeDetail.table.orderAmount': 'Order Amount',
  'pages.activityData.hedgeDetail.table.dealTime': 'Deal Time',
  'pages.activityData.hedgeDetail.table.dealPrice': 'Deal Price',
  'pages.activityData.hedgeDetail.table.dealVolume': 'Deal Volume',
  'pages.activityData.hedgeDetail.table.dealAmount': 'Deal Amount',
  'pages.activityData.hedgeDetail.table.profitLoss': 'PnL',
  'pages.activityData.hedgeDetail.message.fetchFailed': 'Failed to fetch hedge details',
  'pages.activityData.hedgeDetail.message.missingUidForExport': 'Missing UID, unable to export',
  'pages.dashboard.futures.teamMemberCount': 'BD Team Member Count',
  'pages.dashboard.futures.totalCommission': 'Total Commission',
  'pages.dashboard.futures.teamTradingVolume': 'Team Trading Volume',
  'pages.dashboard.futures.activePartner': 'Active Partner',
  'pages.dashboard.futures.addPartner': 'Add Partner',
  'pages.dashboard.futures.performanceRank': 'Performance Rank',
  'pages.dashboard.futures.name': 'Name',
  'pages.dashboard.futures.count': 'Count',
  'pages.dashboard.futures.viewDetail': 'View Detail',
  'pages.dashboard.futures.commissionAmount': 'Commission Amount（Equivalent USDT）',
  'pages.dashboard.futures.last3Months': 'Last 3 Months Commission Statistics',
  'pages.dashboard.futures.month': 'Month',
  'pages.dashboard.futures.last15DaysTeamTradingVolume': 'Last 15 Days Team Trading Volume Statistics',
  'pages.dashboard.futures.date': 'Date',
  'pages.dashboard.futures.volume': 'Volume（USDT）',
  'pages.dashboard.futures.number': 'Number',
  'pages.dashboard.futures.last15DaysActivePartner': 'Last 15 Days Active Partner Statistics',
  'pages.dashboard.futures.totalPartner': 'Total Partner',
  'pages.dashboard.futures.addPartnerNumber': 'Add Partner Number',
  'pages.dashboard.futures.last3MonthsAddPartner': 'Last 3 Months Add Partner Statistics',
  'pages.dashboard.futures.ranking': 'Ranking',
  'pages.dashboard.futures.partnerUid': 'Partner UID',
  'pages.dashboard.futures.commissionIncome': 'Commission Income（USDT）',
  'pages.dashboard.futures.teamNum': 'Team Number',
  'pages.dashboard.futures.commissionIncomeType': 'Commission Income',
  'pages.dashboard.futures.teamTradingVolumeType': 'Team Trading Volume',
  'pages.dashboard.futures.addUserNumType': 'Add User Number',
  'pages.dashboard.futures.yesterdayAddUserNum': 'Yesterday Add User Number',
  'pages.dashboard.futures.directInviteNum': 'Direct Invite Number',
  'pages.dashboard.futures.indirectInviteNum': 'Indirect Invite Number',
  'pages.dashboard.futures.yesterdayAddPersonNum': 'Added yesterday',
  'pages.dashboard.futures.lastAddRatio': 'Last Add Ratio',
  'pages.dashboard.futures.indirectTeamNum': 'Indirect Team Number',
  'pages.dashboard.futures.kycVerifiedNum': 'KYC Verified Number',
  'pages.dashboard.futures.totalVolume': 'Total Volume',
  'pages.dashboard.futures.directVolume': 'Direct Volume',
  'pages.dashboard.futures.indirectVolume': 'Indirect Volume',
  'pages.dashboard.futures.lastVolume': 'Last Volume',
  'pages.dashboard.futures.volumePercent': 'Volume Percent',
  'pages.dashboard.futures.myProfits': 'My Profits',
  'pages.dashboard.futures.totalTeamRebate': 'Commission Total Rebate',
  'pages.dashboard.futures.totalSubTeamRebate': 'Sub Team Commission Rebate',
  'pages.dashboard.futures.myProfitsChart': 'Commission Income Statistics',
  'pages.dashboard.futures.myProfitsChartDescription': 'Commission Income（Equivalent USDT）',
  'pages.dashboard.futures.teamTradingVolumeChart': 'Team Trading Volume Statistics',
  'pages.dashboard.futures.directInviteTradingVolume': 'Direct Invite Trading Volume',
  'pages.dashboard.futures.subTeamTradingVolume': 'Sub Team Trading Volume',
  'pages.dashboard.futures.rechargeChart': 'Recharge/People',
  'pages.dashboard.futures.totalRechargeAmount': 'Total Recharge Amount',
  'pages.dashboard.futures.totalRechargePeople': 'Total Recharge People',
  'pages.dashboard.futures.rechargePeople': 'Recharge People',
  'pages.dashboard.futures.rechargeAmount': 'Recharge Amount',
  'pages.dashboard.futures.rechargeAmountAndPeopleStat': 'Recharge Amount & People Stat',
  'pages.dashboard.futures.promotion': 'Promotion',
  'pages.dashboard.futures.latestUpdateTime': 'Data Update Time',
  'pages.dashboard.futures.dataOverview': 'Data Overview',
  'pages.dashboard.futures.mySubordinates': 'Affiliate',
  'pages.dashboard.futures.subordinateCount': 'Total Affiliates',
  'pages.dashboard.futures.spot': 'Spot',
  'pages.dashboard.futures.futures': 'Futures',
  'pages.dashboard.overview.myCommission': 'Commission',
  'pages.dashboard.overview.myCommissionTooltip':
    'Display current rebate details, current rebate account total = settled rebate + pending rebate (pending rebate will be settled at 6:00 T+1)',
  'pages.dashboard.overview.inviteCode': 'Invite Code',
  'pages.dashboard.overview.customize': 'Customize',
  'pages.dashboard.overview.copyInviteCode': 'Copy Invite Code',
  'pages.dashboard.overview.copyInviteLink': 'Copy Invite Link',
  'pages.dashboard.overview.mySubordinates': 'Affiliate',
  'pages.dashboard.overview.mySubordinatesTooltip':
    'Display the rebate income data and the total number of subordinates under the direct and indirect umbrellas of the currently logged-in user.',
  'pages.dashboard.overview.subordinateCount': 'Total Affiliates',
  'pages.dashboard.overview.person': 'Person',
  'pages.dashboard.recentResults.title': 'Recent Performance',
  'pages.dashboard.recentResults.tooltip':
    'Display all transaction data of yourself and subordinate users based on the selected time range and UID. Data display has normal delay.',
  'pages.dashboard.recentResults.uidPlaceholder': 'Search sub-affiliates UID',
  'pages.dashboard.recentResults.search': 'Search',
  'pages.dashboard.recentResults.reset': 'Reset',
  'pages.dashboard.recentResults.commission': 'Commission',
  'pages.dashboard.recentResults.fee': 'Fee',
  'pages.dashboard.recentResults.volume': 'Volume',
  'pages.dashboard.recentResults.depositAmount': 'Deposit Amount',
  'pages.dashboard.recentResults.traderCount': 'Trader Count',
  'pages.dashboard.recentResults.teamNewCount': 'Team New Count',
  'pages.dashboard.recentResults.chartDescription':
    'Data is linked with recent performance. Display trend chart filtered by time and converted to USDT statistics.',
  'pages.dashboard.chartArea.commission': 'Commission',
  'pages.dashboard.chartArea.fee': 'Fee',
  'pages.dashboard.chartArea.volume': 'Volume',
  'pages.dashboard.chartArea.depositAmount': 'Deposit Amount',
  'pages.dashboard.chartArea.traderCount': 'Trader Count',
  'pages.dashboard.chartArea.teamNewCount': 'Team New Count',
  'pages.dashboard.chartArea.futures': 'Futures',
  'pages.dashboard.chartArea.spot': 'Spot',
  'pages.dashboard.chartArea.total': 'Total',
  'pages.dashboard.chartArea.dropdownArrow': 'Dropdown Arrow',
  'pages.dashboard.chartPie.futures': 'Futures',
  'pages.dashboard.chartPie.spot': 'Spot',
  'pages.dashboard.chartPie.total': 'Total',
  'pages.dashboard.chartPie.type': 'Type',
  'pages.dashboard.chartPie.percentage': 'Percentage',
  'pages.dashboard.chartPie.quantity': 'Quantity',
  'pages.dashboard.chartPie.unit': 'Unit: USDT',
  'pages.dashboard.chartPie.chartTitle': 'Futures and Spot Ratio Chart',
  'pages.dashboard.dailyResults.title': 'Daily Performance',
  'pages.dashboard.dailyResults.date': 'Date',
  'pages.dashboard.dailyResults.commission': 'Commission',
  'pages.dashboard.dailyResults.commissionTooltip':
    'Commission includes multiple currencies, converted to USDT at exchange rate',
  'pages.dashboard.dailyResults.volume': 'Volume',
  'pages.dashboard.dailyResults.volumeTooltip':
    'Volume includes multiple currencies, converted to USDT at exchange rate',
  'pages.dashboard.dailyResults.traderCount': 'Trader Count',
  'pages.dashboard.dailyResults.traderCountTooltip':
    'Count of daily traders (deduplicated) within the selected time range, deduplicated by natural day, can be counted repeatedly across days, non-standard person-times',
  'pages.dashboard.dailyResults.teamNewCount': 'Team New Count',
  'pages.dashboard.dailyResults.teamNewCountTooltip':
    'Number of successful registrations invited by subordinate agents, aggregated by day',
  'pages.dashboard.dailyResults.fee': 'Fee',
  'pages.dashboard.dailyResults.feeTooltip': 'Fee includes multiple currencies, converted to USDT at exchange rate',
  'pages.dashboard.dailyResults.depositCount': 'Deposit Count',
  'pages.dashboard.dailyResults.depositCountTooltip':
    'Daily deposit count statistics of subordinate agents, repeated deposits count as 1 person',
  'pages.dashboard.dailyResults.depositAmount': 'Deposit Amount',
  'pages.dashboard.dailyResults.depositAmountTooltip':
    'Including on-chain deposits and internal transfers, aggregated by day',
  'pages.dashboard.dailyResults.withdrawCount': 'Withdraw Count',
  'pages.dashboard.dailyResults.withdrawCountTooltip': 'Daily withdraw count statistics of subordinate agents',
  'pages.dashboard.dailyResults.withdrawAmount': 'Withdraw Amount',
  'pages.dashboard.dailyResults.withdrawAmountTooltip':
    'Including on-chain withdrawals and U-card withdrawals, converted to USDT',
  'pages.dashboard.dailyResults.futures': 'Futures:',
  'pages.dashboard.dailyResults.spot': 'Spot:',
  'pages.dashboard.recentPerformanceVolume.depositAmount': 'Deposit Amount',
  'pages.dashboard.recentPerformanceVolume.depositAmountTooltip':
    'Statistics for on-chain deposits, credit card purchases, and internal transfers',
  'pages.dashboard.recentPerformanceVolume.withdrawAmount': 'Withdrawal Amount',
  'pages.dashboard.recentPerformanceVolume.withdrawAmountTooltip':
    'Statistics for on-chain withdrawals, U-card withdrawals, and internal transfers',
  'pages.dashboard.recentPerformanceVolume.teamProfitLoss': 'Team Profit/Loss',
  'pages.dashboard.recentPerformanceVolume.teamProfitLossTooltip':
    'Statistics for realized profit and loss of all users under the umbrella',
  'pages.dashboard.recentPerformanceVolume.traderCount': 'Trader Count',
  'pages.dashboard.recentPerformanceVolume.traderCountTooltip':
    'Statistics for spot and futures traders under the umbrella',
  'pages.dashboard.recentPerformanceVolume.teamNewCount': 'Team New Count',
  'pages.dashboard.recentPerformanceVolume.teamNewCountTooltip':
    'Statistics for newly registered users across the entire chain under the umbrella',
  'pages.team.title': 'Team Management',
  'pages.team.keywordSearch': 'Keyword Search',
  'pages.team.searchPlaceholderUid': 'Please enter UID',
  'pages.team.searchPlaceholderEmail': 'Please enter email',
  'pages.team.searchPlaceholderPhone': 'Please enter phone number',
  'pages.team.futuresRebate': 'Futures Rebate',
  'pages.team.spotRebate': 'Spot Rebate',
  'pages.team.totalAssetValuationUsdt': 'Total Asset Valuation (Equivalent USDT)',
  'pages.team.spotAccountValuationUsdt': 'Spot Account Valuation (Equivalent USDT)',
  'pages.team.futuresAccountValuationUsdt': 'Futures Account Valuation (Equivalent USDT)',
  'pages.team.transactionTime': 'Transaction Time',
  'pages.team.personalMonthVolume': 'Spot Personal Cumulative Volume (Equivalent USDT)',
  'pages.team.futuresPersonalMonthVolume': 'Futures Personal Cumulative Volume (Equivalent USDT)',
  'pages.team.spotTeamMonthVolume': 'Spot Team Cumulative Volume (Equivalent USDT)',
  'pages.team.futuresTeamMonthVolume': 'Futures Team Cumulative Volume (Equivalent USDT)',
  'pages.team.spotTotalCommissionProfit': 'Spot Total Commission Profit (Equivalent USDT)',
  'pages.team.futuresTotalCommissionProfit': 'Futures Total Commission Profit (Equivalent USDT)',
  'pages.team.futuresLevelDifferenceRebate': 'Futures Level Difference Rebate',
  'pages.team.spotProportionRebate': 'Spot Proportion Rebate',
  'pages.team.notificationEmailLanguage': 'Notification Language',
  'pages.team.languageEnglish': 'English',
  'pages.team.languageChinese': 'Chinese Simplified',
  'pages.team.setSpotRebate': 'Set Spot Rebate',
  'pages.team.yourSpotRebate':
    'Your Spot Rebate：{spotScalesStr}（The sum of the levels you set must not be greater than the proportion of your first level.）',
  'pages.team.setFuturesRebate': 'Set Futures Rebate',
  'pages.team.yourFuturesRebate':
    'Your Futures Rebate：{futuresFriendScaleStr}（Please set a level difference rebate ratio smaller than your own）',
  'pages.team.supportSelfRebate': 'Support Self-Rebate',
  'pages.team.futuresSelfRebateRatio': 'Futures Self-Rebate Ratio',
  'pages.team.spotSelfRebateRatio': 'Spot Self-Rebate Ratio',
  'pages.team.selfRebateRatio': 'Self-Rebate Ratio',
  'pages.team.futuresRebateRatio': 'Futures Rebate Ratio',
  'pages.team.rebateZeroWarning': `Setting the editor's futures commission rate to 0% will affect the commission rates of both their direct and indirect referrals to 0%. Please proceed with caution. Do you still want to set it to 0%?`,
  'pages.team.rebateZeroWarningTip': `Editor's note`,
  'pages.team.rebateDecreaseWarning':
    "Editing the futures rebate ratio downward will affect the rebate ratios of the user's direct and indirect referrals proportionally. Please proceed with caution. Do you want to continue setting the decrease?",
  'pages.team.rebateDecreaseWarningTip': 'Edit Notice',
  'pages.team.rebateDecreaseError':
    'You can only increase or maintain the current rebate ratio. If you need to decrease it, please contact the platform operations staff for an appeal.',
  'pages.team.spotRebateTip':
    'Operational background special configuration, cannot be edited, if you need to contact the relevant operation personnel for operation.',
  'pages.invitationLink.title': 'Invitation Link Management',
  'pages.invitationLink.add': 'Add Link',
  'pages.invitationLink.futuresSelfScale': 'Rebate Ratio (Me)',
  'pages.invitationLink.futuresScale': 'Rebate Ratio (Friend)',
  'pages.invitationLink.registerNum': 'Register Number',
  'pages.invitationLink.status': 'Link Status',
  'pages.invitationLink.my': 'My',
  'pages.invitationLink.friend': 'Friend',
  'pages.invitationLink.myIdentityDescription': 'My Rebate Ratio：{futuresScale} Spot Rebate Ratio：{spotScale}',
  'pages.tradingVolume.futuresTradingVolume': 'Futures Trading Volume',
  'pages.tradingVolume.spotTradingVolume': 'Spot Trading Volume',
  'pages.tradingVolume.futuresTradingVolumeUsdt': 'Futures Trading Volume (Equivalent USDT)',
  'pages.tradingVolume.futuresTradingFeeUsdt': 'Futures Trading Fee (Equivalent USDT)',
  'pages.tradingVolume.spotTradingVolumeUsdt': 'Spot Trading Volume (Equivalent USDT)',
  'pages.tradingVolume.spotTradingFeeUsdt': 'Spot Trading Fee (Equivalent USDT)',
  'pages.tradingVolume.spotTradingFeeTip': 'The fee is the original fee of the transaction, not deducted.',
};
